import qs from "qs"

function normalizeSearchValue(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(normalizeSearchValue)

  if (typeof value === "string") {
    try {
      return JSON.parse(value)
    } catch {
      return value
    }
  }

  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, nested]) => [key, normalizeSearchValue(nested)]),
    )
  }

  return value
}

function stripEmptyValues(search: Record<string, unknown>): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(search).filter(([, value]) => value !== undefined && value !== null && value !== ""),
  )
}

export function parseSearch(searchStr: string): Record<string, unknown> {
  const rawSearch = searchStr.startsWith("?") ? searchStr.slice(1) : searchStr
  const parsed = qs.parse(rawSearch)

  return normalizeSearchValue(parsed) as Record<string, unknown>
}

export function stringifySearch(search: Record<string, unknown>): string {
  const searchStr = qs.stringify(stripEmptyValues(search), {
    arrayFormat: "brackets",
  })

  return searchStr ? `?${searchStr}` : ""
}
